export const InvestorStatuses = {
	InComplete: 1,
	Pending: 2,
	ApprovedByAM: 3,
	ApprovedByCO: 4,
	Archived: 5,
	Blocked: 6,
	WindDown: 7,
	Rejected: 8,
};

export const InvestorStatusList = [
	{
		id: 1,
		name: 'InComplete',
	},
	{
		id: 2,
		name: 'Onboarding',
	},
	{
		id: 3,
		name: 'Compliance',
	},
	{
		id: 4,
		name: 'Approved',
	},
	{
		id: 5,
		name: 'Archived',
	},
	{
		id: 6,
		name: 'Blocked',
	},
	{
		id: 7,
		name: 'Wind-down',
	},
	{
		id: 8,
		name: 'Rejected',
	},
];
